import React, { useState } from "react";

function NonIX({ means, onCommisionChange }) {
  const [selectedOption, setSelectedOption] = useState("");
  const [commision, setCommision] = useState("");

  let content;
  let newCommision;

  switch (means) {
    case "Αεροπλάνο":
      content = <div></div>;
      break;
    case "ΚΤΕΛ":
      content = <div></div>;
      break;
    case "Πλοίο":
      content = <div></div>;
      break;
    case "Τρένο":
      content = (
        <div>
          <label>
            Διαδρομή στον άξονα Θεσ/νίκη-Αθήνα;:
            <label>
              <input
                type="radio"
                value="yes"
                checked={selectedOption === "yes"}
                onChange={() => setSelectedOption("yes")}
                style={{ marginLeft: "10px" }}
              />
              Ναι
            </label>
            <label>
              <input
                type="radio"
                value="no"
                checked={selectedOption === "no"}
                onChange={() => setSelectedOption("no")}
              />
              Όχι
            </label>
          </label>
        </div>
      );
      break;
    default:
      content = <div>No Content</div>;
      break;
  }

  const handleChange = (event) => {
    const inputValue = event.target.value;

    // Only allow positive numeric values
    if (/^\d*$/.test(inputValue)) {
      newCommision = inputValue;
    }
  };

  const handleButtonClick = () => {
    if (newCommision) {
      if (selectedOption === "yes" && means === "Τρένο") {
      } else {
      }
      setCommision(newCommision);
      onCommisionChange(newCommision);
    }
  };

  return (
    <div style={{ marginLeft: "40px" }}>
      {content}

      <input
        type="text"
        onChange={handleChange}
        placeholder="Εισάγετε το ποσό του/των κομίστρων."
        style={{ width: "400px" }}
      />
      <button onClick={handleButtonClick}>Εισαγωγή</button>
    </div>
  );
}

export default NonIX;
